module.exports = __webpack_public_path__ + "static/media/dropdown-arrow.25ac5119.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/dropdown-arrow.svg
// module id = 1189
// module chunks = 0